import {
  InstrumentAction,
  InstrumentEvent,
  InstrumentStatus,
  InstrumentTagType,
  InstrumentUploaderType,
} from '@finverity/graphql';

import { InstrumentApprovalCheckerSubscriptionEvents, InstrumentApprovalConfigs } from '../../../types';
import { InstrumentApprovalCheckerDataGridColId } from '../../instrument-approval-checker-container/constants';

export enum PayerFinanceRequestCheckerFilterIdentifier {
  PayerFinanceRequestChecker = 'PAYER_FINANCE_REQUEST_CHECKER',
  NotFundable = 'NOT_FUNDABLE',
}

export const PAYER_INSTRUMENT_FINANCE_REQUEST_CHECKER_CONFIGS: InstrumentApprovalConfigs = {
  companyType: InstrumentUploaderType.Payer,
  pageTitle: 'shell.navigationMenu.approveFinanceRequestChecker',
  actionsDefs: [
    {
      buttonText: 'instrument-approval.actions.reviewAndApprove',
      buttonSvgIconName: 'fvIconInstrumentApprovalReview',
      buttonAppearance: 'primary',
      actionType: InstrumentAction.PayerFinanceCheckerApprove,
      disabled: true,
      disabledTooltip: null,
    },
    {
      buttonText: 'instrument-approval.actions.reject',
      buttonSvgIconName: 'fvIconInstrumentApprovalReject',
      buttonAppearance: 'outline',
      destructive: true,
      actionType: InstrumentAction.PayerFinanceCheckerReject,
      disabled: true,
    },
  ],
  filtersDefs: [
    {
      identifier: PayerFinanceRequestCheckerFilterIdentifier.PayerFinanceRequestChecker,
      label: 'instrument-approval.pages.payerFinanceChecker.filters.pending',
      params: {
        statuses: [InstrumentStatus.PayerFinancePendingCheckerConfirmation],
        eventType: InstrumentEvent.PayerFinanceMakerApproved,
        tags: {
          notIncludes: [
            InstrumentTagType.Deleted,
            InstrumentTagType.NotFundable,
            InstrumentTagType.NoEligibleFundingWindow,
          ],
        },
      },
      count: 0,
      hiddenColumns: [],
    },
    {
      identifier: PayerFinanceRequestCheckerFilterIdentifier.NotFundable,
      label: 'instrument-approval.filterLabels.notFundable',
      params: {
        statuses: [InstrumentStatus.PayerFinancePendingCheckerConfirmation],
        eventType: InstrumentEvent.PayerFinanceMakerApproved,
        tags: {
          notIncludes: [InstrumentTagType.Deleted],
          includes: [InstrumentTagType.NotFundable, InstrumentTagType.NoEligibleFundingWindow],
        },
      },
      count: 0,
      hiddenColumns: [
        InstrumentApprovalCheckerDataGridColId.DisbursementDate,
        InstrumentApprovalCheckerDataGridColId.Tenor,
        InstrumentApprovalCheckerDataGridColId.RepaymentDate,
        InstrumentApprovalCheckerDataGridColId.AdvanceRate,
        InstrumentApprovalCheckerDataGridColId.PrincipalAmount,
        InstrumentApprovalCheckerDataGridColId.DisbursementAmount,
        InstrumentApprovalCheckerDataGridColId.RepaymentAmount,
        InstrumentApprovalCheckerDataGridColId.NetUnfinancedBalance,
        InstrumentApprovalCheckerDataGridColId.SellerFeesInAdvance,
        InstrumentApprovalCheckerDataGridColId.PayerFeesInAdvance,
        InstrumentApprovalCheckerDataGridColId.SellerFeesInArrears,
        InstrumentApprovalCheckerDataGridColId.PayerFeesInArrears,
        InstrumentApprovalCheckerDataGridColId.TotalSellerFees,
        InstrumentApprovalCheckerDataGridColId.TotalPayerFees,
        InstrumentApprovalCheckerDataGridColId.TotalFees,
      ],
    },
  ],
  subscriptionEvents: <InstrumentApprovalCheckerSubscriptionEvents>{
    approvedSuccess: [
      InstrumentEvent.FunderApprovalMakerPending,
      InstrumentEvent.FundingPending,
      InstrumentEvent.PayerFinanceCheckerApproved,
    ],
    approvedFailure: [InstrumentEvent.PayerFinanceCheckerPending],
    rejected: [InstrumentEvent.PayerFinanceCheckerRejected],
    removed: [InstrumentEvent.InstrumentDeleted],
    updated: [InstrumentEvent.InstrumentEdited],
  },
};
